var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPensionAndInsurance(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.3325 10.4708C15.3667 10.0112 16.5473 10.0112 17.5816 10.4708L19.5601 11.3497C21.0157 11.9968 21.9941 13.4524 21.8247 15.0363C21.4834 18.2275 20.4306 19.9396 18.0005 21.7296C16.7903 22.621 15.1259 22.619 13.9136 21.7306C11.4826 19.9491 10.4005 18.2505 10.0718 15.0148C9.91192 13.4411 10.8891 12.0011 12.3345 11.3585L14.3325 10.4708ZM18.4517 14.5177C18.1594 14.262 17.7247 14.274 17.4468 14.5333L17.3931 14.588L15.6899 16.5353C15.6019 16.6356 15.4496 16.6488 15.3452 16.5655L14.4263 15.8302L14.3638 15.7853C14.0444 15.5789 13.6142 15.6441 13.3716 15.9474C13.1295 16.2505 13.1601 16.6842 13.4312 16.9503L13.4888 17.0011L14.4087 17.7364L14.5493 17.838C15.2708 18.307 16.2407 18.1832 16.8189 17.5226L18.522 15.5763L18.5698 15.5157C18.7897 15.206 18.7435 14.7734 18.4517 14.5177Z",
    fill: "white",
    fillOpacity: 0.9
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPensionAndInsurance);
export default __webpack_public_path__ + "static/media/pension_and_insurance.202924d7f9b25758e8e767175fd6a002.svg";
export { ForwardRef as ReactComponent };